import { ChangeDetectorRef, Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LocalizationService } from '../../../Services/localization-service';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer-component',
  imports: [
    RouterModule,
    TranslatePipe
  ],
  templateUrl: './footer-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './footer-component.scss'
})
export class FooterComponent implements OnInit {
  private readonly localizationService = inject(LocalizationService);
  private readonly cdr = inject(ChangeDetectorRef);
  currentLang = environment.defaultLang;


  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
      if (lang != '') {
        this.currentLang = lang;
        this.cdr.detectChanges();
      }
    });
  }

  currentYear = new Date().getFullYear();

}
